function rawFetch(path, options) {
  return fetch(path, {
    credentials: 'same-origin',
    ...options,
    headers: {
      ...(options.body ? { 'content-type': 'application/json' } : {}),
      ...(options.headers || {})
    }
  });
}

// Shared JSON-fetch helper for admin/CRUD modals — previously copy-pasted
// into 11 separate files with minor drift between copies (some always set
// content-type even on bodyless GET/DELETE, one omitted `credentials`
// explicitly). This is the merged, most complete behavior: content-type is
// only sent when there is a body to describe, and credentials are always
// same-origin (matches the modern fetch() default already relied on
// implicitly by every call site, made explicit here).
//
// One-time 401 retry: several independent modules (i18n, context menu,
// message runtime) each fire their first authenticated request the instant
// setCurrentUser() runs after a fresh login. That request can occasionally
// go out just ahead of the browser actually committing the login response's
// Set-Cookie, so it 401s even though the session is valid — which specific
// endpoint loses the race is random (Nutzer-Meldungen 2026-08-25: i18n/
// labels + messages/unread-count + context-menu/system; 2026-08-26: only
// auth/me, fixed there directly; 2026-08-27: i18n/languages + messages/
// unread-count + context-menu/system again, a DIFFERENT i18n endpoint than
// the first time). Patching one endpoint at a time never sticks because the
// next occurrence just hits a different one. A single short-delayed retry
// here reliably picks up the by-then-committed cookie; a genuinely expired
// or invalid session still 401s on the retry and is reported as normal.
async function apiJson(path, options = {}) {
  let response = await rawFetch(path, options);
  if (response.status === 401) {
    await new Promise(resolve => { setTimeout(resolve, 250); });
    response = await rawFetch(path, options);
  }
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.ok === false) {
    throw Object.assign(new Error(payload.error || payload.message || `HTTP ${response.status}`), { status: response.status, code: payload.code });
  }
  return payload;
}

export {
  apiJson
};
